import React from "react";
import { connect } from "react-redux";
import { loginOps } from "../ducks/login";
import LoginForm from "./loginPage/LoginForm";
import { Transition, Grid, Header, Image, Segment } from "semantic-ui-react";
import logo from "../logo.svg";

class LoginPage extends React.Component {
  state = {
    visible: false
  };

  componentDidMount() {
    this.setState({ visible: true });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    nextProps.loginError !== null &&
      setTimeout(() => this.props.resetError(), 2500);
  }

  componentDidUpdate() {
    this.props.user !== null && this.props.history.push("/");
  }

  handleSubmit = values => this.props.userLogin(values);

  render() {
    return (
      <Transition.Group animation="scale" duration={200}>
        {this.state.visible && (
          <div style={{ padding: "5%" }}>
            <Grid textAlign="center" style={{ height: "100%" }}>
              <Grid.Row>
                <Grid.Column style={{ maxWidth: 450 }}>
                  <Segment>
                    <Header as="h2" color="pink" textAlign="center">
                      <Image src={logo} style={{ width: "45%" }} />
                      <div style={{ marginTop: "-50px" }}>ExtraGestor</div>
                    </Header>
                    <LoginForm
                      onSubmit={values => this.handleSubmit(values)}
                      loginError={this.props.loginError}
                    />
                  </Segment>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Header as="h6" content="20180702.0950" textAlign="right" />
              </Grid.Row>
            </Grid>
          </div>
        )}
      </Transition.Group>
    );
  }
}
const mapStateToProps = state => {
  return {
    user: state.session.user,
    loginError: state.session.loginError
  };
};

const actions = {
  userLogin: loginOps.userLogin,
  resetError: loginOps.resetError
};

export default connect(
  mapStateToProps,
  actions
)(LoginPage);



// WEBPACK FOOTER //
// ./src/pages/LoginPage.jsx